/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from 'react-confirm-alert';         //알럿창(alert confirm)
// import InfiniteScroll from 'react-infinite-scroll-component';
// import CustomerItem from '../../components/customer/CustomerItem'
import CustomerNoticeItem from '../../components/customer/CustomerNoticeItem';
import CustomerWrite from './CustomerWrite';
import fileDownload from 'js-file-download';

import queryString from 'query-string';

import { isMobile, isAndroid, isIOS } from 'react-device-detect';

class CustomerNotice extends Component {
  state = {
    board_id: 9,
    gotoPage: 1,
    pageCount: 1,
    pageSize: 20,
    boardList: [],
    category: 0,
    arrCategory: [],
    write: true,
    hasMore: false,
    strFind: '',
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    const { location } = this.props;
    const { board_id, gotoPage, category, arrCategory } = this.state;

    const query = queryString.parse(location.search);
    let c = query.c;

    if (c === null || c === undefined || c === '') {
    } else {
      if (c.indexOf('|') > -1) {
        const arr = c.split('|');

        arr.map((item, index) => {
          arrCategory.push(item);
        });
      } else {
        arrCategory.push(c);
      }

      this.setState({
        category: parseInt(c),
        arrCategory: arrCategory,
      });
    }

    setTimeout(() => {
      this._getBoardData(board_id, gotoPage, category);
    }, 500);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _getBoardData = async (board_id, gotoPage, category) => {
    const result = await this._getBoardDataApi(board_id, gotoPage, category);
    if (result) {
      const intReturn = result.data[0].intReturn;
      const con = result.data[0].con;
      const pageCount = result.data[0].pageCount;
      const boardList = result.data[0].listData;

      ////console.log(intReturn)
      ////console.log(con)
      if (this._isMounted) {
        if (intReturn === 0) {
          if (con > 0) {
            //console.log('con > 0')
            this.setState({
              gotoPage: gotoPage,
              pageCount: pageCount,
              con: con,
              boardList: boardList,
              hasMore: pageCount < gotoPage ? false : true,
            });
          } else {
            this.setState({
              gotoPage: gotoPage,
              pageCount: pageCount,
              con: con,
              boardList: null,
              hasMore: pageCount < gotoPage ? false : true,
            });
          }
        } else {
          this.setState({
            gotoPage: gotoPage,
            pageCount: pageCount,
            con: con,
            boardList: null,
            hasMore: pageCount < gotoPage ? false : true,
          });
        }
      }
    }
  };
  _getBoardDataApi = (board_id, gotoPage, category) => {
    const { apiUrl, loginId, authId, pkg, history } = this.props;
    const { strFind, arrCategory } = this.state;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');

    let paramCategory;
    if (arrCategory.length <= 0) {
      paramCategory = [0, 1, 2, 3, 4, 5, 9, 10, 11, 12, 13];
      /*
            if(loginId === 'admin' || loginId === 'apexduck') {
                paramCategory = [1, 2, 3, 4, 5, 9, 10, 11, 12]
            } else {
                paramCategory = [1, 2, 3, 4, 5, 11, 12]
            }
            */
      paramCategory = paramCategory.join('|') + '|';
    } else {
      paramCategory = arrCategory.join('|') + '|';
    }

    console.log(paramCategory);

    //POST 방식으로 바꿀수도 있음...
    return axios
      .post(
        apiUrl + '/boardList_pkg_category',
        {
          params: {
            board_id: board_id,
            gotoPage: gotoPage,
            category: category,
            userid: loginId,
            authId: authId,
            strFind: strFind,
            pkg: pkg,
            arrCategory: paramCategory,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(0);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async (gubun) => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    const { board_id, gotoPage, category } = this.state;

    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      if (gubun === 0) {
        this._getBoardData(board_id, gotoPage, category);
      } else {
        this._onItemDel(gubun);
      }
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };

  _renderItem = () => {
    const { boardList } = this.state;

    const list = boardList.map((item, index) => {
      return (
        <CustomerNoticeItem
          key={index}
          idx={item.idx}
          refo={item.refo}
          step={item.step}
          re_level={item.re_level}
          userid={item.userid}
          nicName={item.nicName}
          board_id={item.board_id}
          title={item.title}
          writeDay={item.writeDay}
          charac_img={item.charac_img}
          categoryID={item.categoryID}
          categoryName={item.categoryName}
          content={item.content}
          replay_idx={item.replay_idx}
          onItemDel={this._onItemDel}
          numm={item.numm}
          chkNotice={item.chkNotice}
        />
      );
    });

    return list;
  };
  _totalCategory = (category) => {
    const { board_id, arrCategory } = this.state;
    let paramCategory;
    if (arrCategory.length <= 0) {
    } else {
      paramCategory = [];
      this.setState({
        arrCategory: paramCategory,
      });
    }
    setTimeout(() => {
      this._getBoardData(board_id, 1, category);
    }, 500);
  };
  _toggleCategory = (category) => {
    const { board_id, arrCategory } = this.state;
    // let temp

    const a = arrCategory.findIndex((item, index) => {
      return item === category;
    });

    //console.log(a)

    if (a <= -1) {
      arrCategory.push(category);
    } else {
      arrCategory.splice(a, 1);
    }
    this.setState({
      arrCategory: arrCategory,
    });
    setTimeout(() => {
      this._getBoardData(board_id, 1, category);
    }, 500);
    /*
        if(arrCategory.indexOf(category) > -1) {
            //삭제
            //const temp = arrCategory.replace('|' + category + '|')
            const pos = arrCategory.indexOf(category)
            const temp = arrCategory.substr(pos, arrCategory.length)
            console.log(temp)
            const pos1 = temp.indexOf('|')

            const temp1 = arrCategory.substr(0, pos) + temp.substr(pos1, arrCategory.length)
            console.log(temp1)
            //console.log(temp)
        } else {
            //추가
            temp = arrCategory + category + '|'
            this.setState({
                arrCategory: temp
            })
        }
        */
  };
  _changeCategory = (category) => {
    const { board_id } = this.state;
    this.setState({
      category,
      strFind: '',
    });
    setTimeout(() => {
      this._getBoardData(board_id, 1, category);
    }, 500);
  };
  _showWrite = () => {
    const { write } = this.state;
    this.setState({
      write: !write,
    });
  };
  _onItemDel = async (idx) => {
    //console.log('asdfasdfasdfdas')

    const { board_id, category } = this.state;
    const { loginId } = this.props;
    if (loginId === null || loginId === undefined || loginId === '') {
      //console.log('not login')
    } else {
      //console.log('start del')
      const result = await this._onItemDelApi(idx);

      if (result) {
        const intReturn = result.data[0].intReturn;

        //console.log(intReturn)
        if (intReturn === 0) {
          toast.success('글이 성공적으로 삭제되었습니다.');
          this._getBoardData(board_id, 1, category);
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _onItemDelApi = (idx) => {
    const { apiUrl, loginId, authId, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');

    return axios
      .post(
        apiUrl + '/boardDel',
        {
          params: {
            userid: loginId,
            authId: authId,
            idx: idx,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(idx);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _onChange = (e) => {
    this.setState({
      strFind: e.target.value,
    });
  };
  _onSearch = () => {
    const { board_id, category, strFind } = this.state;

    if (strFind === '' || strFind === null || strFind === undefined) {
      toast.warn('검색어를 입력해 주세요');
    } else {
      this._getBoardData(board_id, 1, category);
    }
  };
  _renderPage = () => {
    const { pageCount, gotoPage, con, board_id, category } = this.state;
    const dataPerPage = isMobile ? 5 : 10; //한페이지에 보여질 레코드 갯수

    const pageNumbers = [];

    const totalPage = Math.ceil(con / dataPerPage); //총페이지수

    let pageCount1;

    if (pageCount > dataPerPage) {
      pageCount1 = dataPerPage;
    } else {
      pageCount1 = pageCount;
    }

    const pageGroup = Math.ceil(gotoPage / pageCount1); //페이지 그룹
    let last = pageGroup * pageCount1;

    if (last > totalPage) {
      last = totalPage;
    }

    let first = last - (pageCount1 - 1); //화면에 보여질 첫번째 페이지 번호

    const next = last + 1;
    // const prev = first - 1;

    if (totalPage < 1) {
      first = last;
    }

    if (first > pageCount1) {
    } else {
    }

    if (next > pageCount1 && next < totalPage) {
    } else {
    }

    for (let j = first; j <= last; j++) {
      pageNumbers.push(j);
    }

    const list = pageNumbers.map((num, index) => {
      return (
        <span
          key={index}
          style={{ cursor: 'pointer' }}
          onClick={() => this._getBoardData(board_id, num, category)}
          className={gotoPage === num ? 'on' : null}
        >
          {num}
        </span>
        /*<a href="#" className={gotoPage === num ? "active" : null } onClick={()=>this._page(num)} key={index}>{num}</a>*/
      );
    });

    return (
      <Fragment>
        {first > pageCount1 ? (
          <span onClick={this._onPrev}>이전</span>
        ) : (
          <span style={{ backgroundColor: 'transparent' }}></span>
        )}
        {list}
        {next > pageCount1 && next < totalPage ? (
          <span onClick={this._onNext}>다음</span>
        ) : (
          <span style={{ backgroundColor: 'transparent' }}></span>
        )}
      </Fragment>
    );
  };
  _onPrev = () => {
    const { board_id, gotoPage, category } = this.state;

    if (gotoPage === 1) {
      //alert('페이지의 처음입니다.')
      toast.warn('페이지의 처음입니다.');
    } else {
      this._getBoardData(board_id, gotoPage - 1, category);
    }
  };
  _onNext = () => {
    const { board_id, gotoPage, category, pageCount } = this.state;
    if (gotoPage + 1 >= pageCount) {
      toast.warn('페이지의 마지막입니다.');
      //alert('페이지의 마지막입니다.')
    } else {
      this._getBoardData(board_id, gotoPage + 1, category);
    }
  };
  _onKeyUp = (e) => {
    if (e.keyCode === 13) {
      this._onSearch();
    }
  };
  _download = () => {
    // const { gubun } = this.state;
    let url;
    let filename;

    url = 'https://www.aniplustv.com/download/DEXT5_Uninstall.zip';
    filename = 'DEXT5_Uninstall.zip';

    axios
      .get(url, {
        responseType: 'blob',
      })
      .then((res) => {
        fileDownload(res.data, filename);
      });
  };

  render() {
    const { loginId } = this.props;
    const {
      board_id,
      boardList,
      category,
      write,
      strFind,
      pageCount,
      arrCategory,
    } = this.state;

    return (
      <Fragment>
        {write ? (
          <CustomerWrite
            board_id={board_id}
            category={category}
            toggleWrite={this._showWrite}
            writeOk={this._getBoardData}
          />
        ) : (
          <div className="service_content">
            <div className="bsearch_area">
              <div className="bsearch">
                <div className="select_div">
                  <select>
                    <option>제목</option>
                  </select>
                </div>

                <input
                  type="text"
                  id=""
                  name="strFind"
                  value={strFind}
                  className="stxt"
                  onChange={this._onChange}
                  onKeyUp={this._onKeyUp}
                />
                <input
                  type="button"
                  id=""
                  name=""
                  value="검색"
                  className="sbtn"
                  onClick={this._onSearch}
                />
              </div>

              <h2>
                <a
                  onClick={() => this._totalCategory('0')}
                  style={{ cursor: 'pointer' }}
                  className={arrCategory.length === 0 ? 'on' : null}
                >
                  #전체
                </a>
                {/*<a href="#" className="">#공지</a>*/}
                <a
                  onClick={() => this._toggleCategory('1')}
                  style={{ cursor: 'pointer' }}
                  className={arrCategory.indexOf('1') > -1 ? 'on' : null}
                >
                  #VOD
                </a>
                <a
                  onClick={() => this._toggleCategory('2')}
                  style={{ cursor: 'pointer' }}
                  className={arrCategory.indexOf('2') > -1 ? 'on' : null}
                >
                  #멤버십
                </a>
                <a
                  onClick={() => this._toggleCategory('3')}
                  style={{ cursor: 'pointer' }}
                  className={arrCategory.indexOf('3') > -1 ? 'on' : null}
                >
                  #환불
                </a>
                <a
                  onClick={() => this._toggleCategory('4')}
                  style={{ cursor: 'pointer' }}
                  className={arrCategory.indexOf('4') > -1 ? 'on' : null}
                >
                  #상품
                </a>
                <a
                  onClick={() => this._toggleCategory('5')}
                  style={{ cursor: 'pointer' }}
                  className={arrCategory.indexOf('5') > -1 ? 'on' : null}
                >
                  #배송
                </a>
                <a
                  onClick={() => this._toggleCategory('13')}
                  style={{ cursor: 'pointer' }}
                  className={arrCategory.indexOf('13') > -1 ? 'on' : null}
                >
                  #신작요청
                </a>
                <a
                  onClick={() => this._toggleCategory('9')}
                  style={{ cursor: 'pointer' }}
                  className={arrCategory.indexOf('9') > -1 ? 'on' : null}
                >
                  #자막오류
                </a>
                <a
                  onClick={() => this._toggleCategory('10')}
                  style={{ cursor: 'pointer' }}
                  className={arrCategory.indexOf('10') > -1 ? 'on' : null}
                >
                  #저작권 침해
                </a>

                {/*<a onClick={()=>this._changeCategory(101)} style={{cursor: 'pointer'}} className={category === 101? "on" : null }>#쇼핑</a>*/}
                {/*<a onClick={()=>this._changeCategory(12)} style={{cursor: 'pointer'}} className={category === 12 ? "on" : null }>#저작권</a>*/}
                <a
                  onClick={() => this._toggleCategory('12')}
                  style={{ cursor: 'pointer' }}
                  className={arrCategory.indexOf('12') > -1 ? 'on' : null}
                >
                  #이벤트
                </a>
                <a
                  onClick={() => this._toggleCategory('11')}
                  style={{ cursor: 'pointer' }}
                  className={arrCategory.indexOf('11') > -1 ? 'on' : null}
                >
                  #기타
                </a>
                {loginId === 'admin' ? (
                  <a
                    style={{
                      cursor: 'pointer',
                      right: 80,
                      position: 'absolute',
                    }}
                    className="on"
                    onClick={this._showWrite}
                  >
                    1:1 문의하기
                  </a>
                ) : null}
              </h2>
            </div>
            <div>
              <table
                width="100%"
                border="0"
                cellSpacing="0"
                cellPadding="0"
                className="new_board"
              >
                <colgroup>
                  <col width="108" />
                  <col width="94" />
                  <col width="" />
                  <col width="194" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>번호</th>
                    <th>카테고리</th>
                    <th>제목</th>
                    <th>등록일</th>
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      <span className="icon notice">공지</span>
                    </td>
                    <td className="txt">
                      <span style={{ color: 'orange' }}>운영자(admin)</span>
                      <a style={{ cursor: 'pointer' }} onClick={this._download}>
                        멀티다운로더 삭제 프로그램(DEXT5_Uninstall.zip) 다운로드
                        하기
                      </a>
                    </td>
                    <td>2021.01.04</td>
                  </tr>
                  {boardList ? this._renderItem() : null}
                </tbody>
              </table>

              <div className="page_no new_page">{this._renderPage()}</div>
            </div>
            {/*<div className="vod_loading"><img src="img/vod/vod_loading.png"/></div>*/}
          </div>
        )}

        {/* boardList ? (
                    <div className="service_content">
                        <h2>
                            <a style={{cursor: 'pointer'}} className={category === 0 ? 'on' : null } onClick={()=>this._changeCategory(0)}>전체</a>
                            <a style={{cursor: 'pointer'}} className={category === 101 ? 'on' : null } onClick={()=>this._changeCategory(101)}>쇼핑</a>
                            {loginId === 'admin' ? <a style={{cursor: 'pointer', right: 80, position: 'absolute'}} className='on' onClick={this._showWrite} >공지쓰기</a> : null }
                        </h2>
                        {write ? (
                            <CustomerWrite 
                                board_id={board_id}
                                category={category}
                                toggleWrite = {this._showWrite}
                                writeOk = {this._getBoardData}
                            />
                        ): (
                            <div>
                            
                                <InfiniteScroll
                                    dataLength={this.state.boardList.length}
                                    next={() => this._getBoardData(board_id, gotoPage, category)}
                                    hasMore={ hasMore }
                                    loader={<div className="vod_loading"></div>}
                                    endMessage={
                                        <p style={{textAlign: 'center'}}>
                                        
                                        </p>
                                    }
                                    style={{overflow: 'hidden', textAlign: 'center'}}
                                >
                                <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                                <colgroup><col width="150"/><col width="150"/><col width=""/></colgroup>
                                <tbody>
                                    <tr>
                                        <th>등록일</th>
                                        <th>구분</th>
                                        <th>제목</th>
                                    </tr>
                                    { boardList ? this._renderItem() : null}
                                </tbody>
                                </table>
                                </InfiniteScroll> 
                              
                            
                            </div>
                        ) }
                        
                       
                    </div>
                    ) : null */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(CustomerNotice));
